module.exports = __webpack_public_path__ + "static/media/30_tn.9bbe9449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/30_tn.jpg
// module id = 666
// module chunks = 0